<template>
  <div class="credits-indicator">
    <button
      id="popover-credits"
      class="credits-trigger-btn"
      title="Créditos y saldo"
    >
      <i class="el-icon-coin"></i>
    </button>

    <b-popover
      target="popover-credits"
      triggers="hover click"
      placement="bottomleft"
      custom-class="credits-popover"
    >
      <template v-slot:title>Créditos y saldo</template>

      <div class="credits-body">
        <div class="credits-row">
          <div class="credits-row-label">
            <i class="el-icon-chat-dot-round"></i>
            <span>Saldo de WhatsApp</span>
          </div>
          <div v-if="loading" class="credits-row-value">…</div>
          <div v-else-if="wallet.has_wallet" class="credits-row-value">
            ${{ wallet.balance_usd.toFixed(2) }}
          </div>
          <div v-else class="credits-row-value credits-row-value--muted">
            Módulo inactivo
          </div>
        </div>
        <p class="credits-row-hint">
          No caduca. Se descuenta por mensaje enviado hasta que se agote.
        </p>

        <div class="credits-divider"></div>

        <div class="credits-row">
          <div class="credits-row-label">
            <i class="el-icon-magic-stick"></i>
            <span>Créditos de IA</span>
          </div>
          <div v-if="loading" class="credits-row-value">…</div>
          <div v-else-if="ai.unlimited" class="credits-row-value">
            Ilimitados
          </div>
          <div v-else class="credits-row-value">
            {{ ai.remaining }}
            <span class="credits-row-value-of">/ {{ ai.limit }}</span>
          </div>
        </div>
        <p class="credits-row-hint">
          Se reinician el día 1 de cada mes. Lo que no uses no se acumula.
        </p>

        <router-link :to="{ name: 'plans.additionals' }" class="credits-cta">
          Comprar / recargar
        </router-link>
      </div>
    </b-popover>
  </div>
</template>

<script>
import payService from "@/modules/dashboard/plans/services/payService";

export default {
  name: "CreditsIndicator",
  data: () => ({
    loading: true,
    wallet: { has_wallet: false, balance_usd: 0 },
    ai: { remaining: 0, limit: 0, unlimited: false }
  }),
  methods: {
    async load() {
      try {
        const [walletRes, aiRes] = await Promise.all([
          payService.getWhatsappWalletBalance().catch(() => null),
          payService.getAiCreditsStatus().catch(() => null)
        ]);

        if (walletRes && walletRes.data && walletRes.data.success) {
          this.wallet = {
            has_wallet: false,
            balance_usd: 0,
            ...walletRes.data.data
          };
        }
        if (aiRes && aiRes.data && aiRes.data.success) {
          const credits = aiRes.data.data.credits || {};
          this.ai = {
            remaining: credits.remaining ?? 0,
            limit: credits.limit ?? 0,
            unlimited: !!credits.unlimited
          };
        }
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style scoped lang="scss">
.credits-trigger-btn {
  position: relative;
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background: #2d2b55;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.15s;
  margin-right: 10px;
  font-size: 16px;

  &:hover {
    background: #3ecfb4;
  }
}
</style>

<style lang="scss">
.credits-popover {
  max-width: 320px;
  border: 1px solid #e4eaf6 !important;
  box-shadow: 0 8px 28px rgba(45, 43, 85, 0.18) !important;

  .popover-body {
    padding: 16px 18px;
  }
}
.credits-body {
  min-width: 240px;
}
.credits-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.credits-row-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #31355c;

  i {
    color: #909399;
  }
}
.credits-row-value {
  font-size: 15px;
  font-weight: 700;
  color: #31355c;
  white-space: nowrap;
}
.credits-row-value--muted {
  font-size: 12px;
  font-weight: 600;
  color: #909399;
}
.credits-row-value-of {
  font-size: 12px;
  font-weight: 600;
  color: #909399;
}
.credits-row-hint {
  font-size: 11px;
  color: #909399;
  margin: 2px 0 0;
}
.credits-divider {
  height: 1px;
  background: #e4eaf6;
  margin: 10px 0;
}
.credits-cta {
  display: block;
  text-align: center;
  margin-top: 12px;
  padding: 8px 0;
  border-radius: 8px;
  background: #3fdbbf;
  color: #fff !important;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    opacity: 0.9;
  }
}
</style>
